
setTimeout(() => {
  const f = document.querySelector('.pk-fs-fill');
  if (f) {
    f.style.setProperty('width', '35%', 'important');
    f.style.setProperty('background', 'magenta', 'important');
    console.log('PKFS smoke: forced 35% visible');
  } else {
    console.log('PKFS smoke: .pk-fs-fill not found yet');
  }
}, 1000);

/* PAKAL • Drawer Free-Shipping Progress • resilient init */
(function () {
  const SEL = {
    wrap: '.pk-free-ship',
    amt:  '.pk-free-ship .pk-fs-amt',
    track: '.pk-free-ship .pk-fs-track',
    fill: '.pk-free-ship .pk-fs-fill',
    drawer: 'cart-drawer, .cart-drawer, #CartDrawer'
  };

  // expose for debug
  window.pkFS = window.pkFS || {};

  function getWrap() { return document.querySelector(SEL.wrap); }
  function getThresholdShekels() {
    const el = getWrap();
    const raw = el && parseFloat(el.getAttribute('data-threshold'));
    return Number.isFinite(raw) ? raw : 100; // 100 ₪ ברירת מחדל
  }
  function toAgorot(ils) { return Math.round(ils * 100); }
  function clamp01(x) { return Math.max(0, Math.min(1, x)); }
  function formatIls(cents) {
    try { return new Intl.NumberFormat('he-IL',{style:'currency',currency:'ILS',maximumFractionDigits:0}).format(cents/100); }
    catch(e){ return Math.round(cents/100) + ' ₪'; }
  }
function setUI(totalCents, thresholdCents) {
  const wrap  = document.querySelector('.pk-free-ship');
  const amt   = document.querySelector('.pk-free-ship .pk-fs-amt');
  const track = document.querySelector('.pk-free-ship .pk-fs-track');
  const fill  = document.querySelector('.pk-free-ship .pk-fs-fill');
  const knob  = document.querySelector('.pk-free-ship .pk-fs-knob');
  if (!wrap || !track || !fill) return;

  const p = Math.max(0, Math.min(1, totalCents / thresholdCents));
  const percent = Math.round(p * 100);

  // עדכון הפס
  fill.style.width = percent + '%';
  track.setAttribute('aria-valuenow', String(percent));
  // אכיפה נגד דריסות תמה
  fill.style.setProperty('height','100%','important');
  fill.style.setProperty('display','block','important');
  fill.style.setProperty('position','absolute','important');
  fill.style.setProperty('inset','0 auto 0 0','important');
  fill.style.setProperty('z-index','1','important');
  fill.style.setProperty('background','linear-gradient(90deg,#3C5233,#7EB1A1)','important');

  // מיקום הכפתור והבטחת נראות בקצה
  if (knob) {
    const safePercent = Math.max(1, Math.min(percent, 100));
    knob.style.left = safePercent + '%';

    if (percent >= 1) knob.classList.add('pk-fs-visible');
    else knob.classList.remove('pk-fs-visible');

    if (percent >= 99) knob.classList.add('pk-fs-end');
    else knob.classList.remove('pk-fs-end');
  }

  // טקסט, מצבים, ואפקטים
  if (totalCents >= thresholdCents) {
    const wasEligible = wrap.dataset.eligible === '1';
    wrap.classList.add('pk-fs-done');
    wrap.dataset.eligible = '1';

    if (amt) {
      amt.textContent = 'זכאים למשלוח חינם';
      // פופ חד פעמי ברגע החצייה
      if (!wasEligible) {
        amt.classList.add('pk-amt-burst');
        setTimeout(() => amt.classList.remove('pk-amt-burst'), 2200);
      }
      // פולס מחזורי קבוע בזמן זכאות
      amt.classList.add('pk-amt-pulse');
    }

    if (knob) {
      knob.classList.add('pk-fs-win');
      knob.classList.remove('pk-fs-attn');
    }
  } else {
    wrap.classList.remove('pk-fs-done');
    wrap.dataset.eligible = '0';

    const remain = thresholdCents - totalCents;
    if (amt) {
      amt.textContent = 'נותרו ' + formatIls(remain);
      amt.classList.remove('pk-amt-burst','pk-amt-pulse');
    }

    if (knob) {
      if (percent >= 1) {
        knob.classList.add('pk-fs-attn', 'pk-fs-visible');
        knob.classList.remove('pk-fs-win');
      } else {
        knob.classList.remove('pk-fs-attn', 'pk-fs-win', 'pk-fs-visible');
      }
    }
  }
}




  async function fetchCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('cart.js failed');
      return await res.json();
    } catch (e) {
      console.warn('PK FS: /cart.js error', e);
      return null;
    }
  }

  async function refresh() {
    const wrap = getWrap();
    if (!wrap) return;
    const cart = await fetchCart();
    if (!cart) return;
    setUI(cart.total_price || 0, toAgorot(getThresholdShekels()));
  }
  window.pkFS.refresh = refresh;

  // wait until the HTML exists, then wire everything
  function whenExists(selectors, cb, timeoutMs=8000) {
    const start = Date.now();
    const tryNow = () => {
      const ok = selectors.every(sel => document.querySelector(sel));
      if (ok) { cb(); return; }
      if (Date.now() - start > timeoutMs) return;
      requestAnimationFrame(tryNow);
    };
    tryNow();
  }

  function wireEvents() {
    // רענון באירועי עגלה נפוצים
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('cart:update', refresh);
    document.addEventListener('product:added', refresh);

    // אירועי Shopify Sections בעת טעינה דינמית
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:select', refresh);

    // פתיחת המגירה בלחיצה
    document.addEventListener('click', function (e) {
      const t = e.target.closest('[data-action="open-drawer"], .js-drawer-open, .js-drawer-open-cart');
      if (t) setTimeout(refresh, 60);
    });

    // גיבוי: תצפית DOM על המגירה אם קיימת
    const drawerEl = document.querySelector(SEL.drawer) || document.body;
    if (window.MutationObserver && drawerEl) {
      const mo = new MutationObserver(() => refresh());
      mo.observe(drawerEl, { childList: true, subtree: true });
    }
  }

  function init() {
    // נרשמים לאירועים גם אם ה־HTML עוד לא שם
    wireEvents();

    // מחכים שה־HTML שלך יוזרק ואז מרעננים פעם ראשונה
    whenExists([SEL.wrap], () => {
      refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // כלי דיבוג קצר
  window.pkFS.debug = () => {
    const el = getWrap();
    console.log('PK FS debug', {
      html_found: !!el,
      threshold_shekels: getThresholdShekels(),
      selectors: SEL
    });
    refresh();
  };
})();
